import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[autoFocusAndSelect]',
})
export class AutoFocusOnShowDirective implements OnInit {

  constructor(private el: ElementRef) {
    if (!el.nativeElement['focus']) {
      throw new Error('Element does not accept focus.');
    }
  }

  ngOnInit(): void {
    const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
    setTimeout(() => {
        input.focus();
        input.select();
    }, 1);
  }
}